import React, { Dispatch, SetStateAction, useEffect, useMemo, useState } from "react";
import { Table, Button, Input, PaginationItem, PaginationLink, Pagination, Row, Col, Label, FormGroup } from "reactstrap"
import { isWeekday } from "../../../../functions/CalendarFunctions";
import { ReactComponent as IconoExcel } from "../../../../assets/icons/HorasExtras/Excel.svg"
import { ReactComponent as EditarSVG } from "../../../../../assets/icons/editar.svg";
import ModalCargando from 'components/Varios/ModalCargando';
import { ActualizarInfoTabla, informacionCompletaTablaCUR, informacionTablaHE, informacionTablaHEporCUR, tablaCurHistorial, tablaCurSingular } from "./FunctionsAsignarCur"
import DatePickerBlueColor from "../../../Varios/DatePicker/DatePickerBlueColor";
import MonthDatePicker from "../../../Varios/DatePicker/MonthDatePicker";
import YearDatePicker from "../../../Varios/DatePicker/YearDatePicker";
import { InfoPersonasHE, solicitudesPersonas } from "./typesAsignarCur";
import { alertService } from "../../../Varios/alert_service";
import Cargando from "../../../Varios/Cargando";
import { showAlert } from "../Parametros Horas Extras/Actividades/ActividadesHorasExtras";
import { table } from "console";
import Swal from "sweetalert2";
import { useCallback } from "react";
import { string } from "yargs";
import { GetDateObjectFromDate, GetDateObjectFromIsoFormat, ObtenerFechaFormatoLocal, ObtenerFechaFromIsoFormat, ObtenerFechaTimeZoneLocalISO } from "../../../../functions/DatesFunctions";
import Datepicker from "../../../Varios/Datepicker";
import { Card } from "react-bootstrap";
import { number, object } from "prop-types";
import ModalConfirmacion from "../../../Varios/Modals/ModalConfirmacion";
import { relative } from "path";
import TableAsignacionCur from "./TableAsignacionCUR";


export default function PruebaAsignarCur() {
    var contenidoTabla: InfoPersonasHE[] = [
        //infoPersona: {
        //    identificacion: "",
        //    nombre: "",
        //    unidad: "",
        //    regimen: "",
        //    rmu: 0
        //},
        //infoSolicitud: {
        //    estado: "",
        //    HeSumplementarias: 0,
        //    HeExtraordinarias: 0,
        //    THorasExtras: 0,
        //    VHeSumplementarias: 0,
        //    VheExtraordinarias: 0,
        //    TVHorasExtras: 0,
        //    fechaCur: 0,
        //    numeroCur: 0,
    ]


    const TITULO_PANTALLA = `MANEJO DEL CUR DE PAGOS`;

    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [numeroCur, setNumeroCur] = useState<number | null>(null);
    const [fechaPress, setfechaPress] = useState<string | null>(null);
    const [fechaCur, setFechaCur] = useState<string | null>(null);
    const [consultaCur, setconsultaCur] = useState<number | null>(null);

    const [fechaPago, setfechaPago] = useState<Date | null>(null);
    const [statemes, setstatemes] = useState<Date | null>(null);
    const mes = statemes?.getMonth();
    const anio = statemes?.getFullYear();

    const [contentTabla, setContentTabla] = useState<InfoPersonasHE[]>(contenidoTabla);
    const [CursUnico, setCursUnico] = useState<number[]>([]);
    const [CursHistorico, setCursHistorico] = useState<number[]>([]);
    const [editandoCUR, seteditandoCur] = useState<InfoPersonasHE[] | undefined>(undefined);

    const [contenidoSeleccionado, setcontenidoSeleccionado] = useState<{ [key: number]: InfoPersonasHE }>([]);
    // const [tablaCS, settablaCS] = useState<InfoPersonasHE[]>([]);
    const [estadoPantalla, setestadoPantalla] = useState<string>("PP");
    const [loadingAccion, setloadingAccion] = useState<boolean>(false);
    const [nuevoCur, setnuevoCur] = useState<boolean>(false);

    //const aprob = contentTabla.filter
    const stylesInput: React.CSSProperties = {
        textAlign: 'center',
        width: '90%',
        textSizeAdjust: 'auto',
        fontFamily: "Roboto",
        fontSize: "1.0em",
        paddingLeft: "20px",
    }

    //INFORMACION DE TABLA FILTRADA POR MES Y AñO
    async function obtenerTablaInfo(mes: number | undefined, anio: number | undefined, enero: boolean) {
        setloadingAccion(true);
        if (anio && mes) {
            if (enero) {
                var TablaInfo = await informacionTablaHE((anio), 1);
            } else {
                var TablaInfo = await informacionTablaHE((anio), (mes + 1));
            }
            if (TablaInfo.status == 200 && TablaInfo.dataResponse) {
                var copia = [...TablaInfo.dataResponse];
                copia.map((c) => {
                    var fecha = ObtenerFechaFromIsoFormat(c.infoSolicitud.fechaCur);
                    var fechaP = ObtenerFechaFromIsoFormat(c.infoSolicitud.fechaPago);
                    c.infoSolicitud.fechaPago = fechaP;
                    c.infoSolicitud.fechaCur = fecha;
                })
                setContentTabla(copia);
                setErrorMessage(null);
            } else {
                setContentTabla(contenidoTabla);
                setErrorMessage(typeof TablaInfo.errorMessage === 'string' ? TablaInfo.errorMessage : 'Error desconocido');
                showAlert(typeof TablaInfo.errorMessage === 'string' ? TablaInfo.errorMessage : 'Error desconocido', false);
            }

        }
        setloadingAccion(false);
    };

    //INFORMACION DE TABLA FILTRADA POR CUR
    async function obtenerTablaCUR(cur: number | null) {
        setloadingAccion(true);
        if (cur) {
            const TablaInfo = await informacionTablaHEporCUR(cur);
            if (TablaInfo.status == 200 && TablaInfo.dataResponse) {
                var copia = [...TablaInfo.dataResponse];
                copia.map((c) => {
                    var fecha = ObtenerFechaFromIsoFormat(c.infoSolicitud.fechaCur);
                    var fechaP = ObtenerFechaFromIsoFormat(c.infoSolicitud.fechaPago);
                    c.infoSolicitud.fechaCur = fecha;
                    c.infoSolicitud.fechaPago = fechaP;
                })
                setContentTabla(copia);
                setErrorMessage(null);
            } else {
                setContentTabla(contenidoTabla);
                setErrorMessage(typeof TablaInfo.errorMessage === 'string' ? TablaInfo.errorMessage : 'Error desconocido');
                showAlert(typeof TablaInfo.errorMessage === 'string' ? TablaInfo.errorMessage : 'Error desconocido', false);
            }
        }
        setloadingAccion(false);
    };
    //INFORMACION DE TODOS LOS DATOS DE LA TABLA POR CUR
    async function obtenerValoresCompletos(cur: number | null) {
        setloadingAccion(true);
        if (cur) {
            const TablaInfo = await informacionCompletaTablaCUR(cur);
            if (TablaInfo.status == 200 && TablaInfo.dataResponse) {
                var copia = [...TablaInfo.dataResponse];
                copia.map((c) => {
                    var fecha = ObtenerFechaFromIsoFormat(c.infoSolicitud.fechaCur);
                    var fechaP = ObtenerFechaFromIsoFormat(c.infoSolicitud.fechaPago);
                    c.infoSolicitud.fechaCur = fecha;
                    c.infoSolicitud.fechaPago = fechaP;
                })
                setContentTabla(copia);
                setErrorMessage(null);
            } else {
                setContentTabla(contenidoTabla);
                setErrorMessage(typeof TablaInfo.errorMessage === 'string' ? TablaInfo.errorMessage : 'Error desconocido');
                showAlert(typeof TablaInfo.errorMessage === 'string' ? TablaInfo.errorMessage : 'Error desconocido', false);
            }
        }
        setloadingAccion(false);
    };

    async function onInitComponent() {
        const curSingular = await tablaCurSingular();
        const curHistorial = await tablaCurHistorial();
        if (curSingular.status == 200 && curSingular.dataResponse) {
            setCursUnico(curSingular.dataResponse);
            setErrorMessage(null);
        } else {
            setCursUnico([]);
            setErrorMessage(typeof curSingular.errorMessage === 'string' ? curSingular.errorMessage : 'Error desconocido');
            showAlert(typeof curSingular.errorMessage === 'string' ? curSingular.errorMessage : 'Error desconocido', false);
        }

        if (curHistorial.status == 200 && curHistorial.dataResponse) {
            setCursHistorico(curHistorial.dataResponse);
            setErrorMessage(null);
            if (curHistorial.dataResponse.length < 1 && estadoPantalla == "PP") {
                setestadoPantalla("SA");
            }
        } else {
            setCursHistorico([]);
            setErrorMessage(typeof curHistorial.errorMessage === 'string' ? curHistorial.errorMessage : 'Error desconocido');
            showAlert(typeof curHistorial.errorMessage === 'string' ? curHistorial.errorMessage : 'Error desconocido', false);
        }
    }

    const handleSelectionChange = (nuevaSeleccion) => {
        setcontenidoSeleccionado(nuevaSeleccion);
    };

    const handleSelectionError = (nuevaSeleccion) => {
        let seleccion = { ...contenidoSeleccionado };

        if (loadingAccion === true) {
            nuevaSeleccion.forEach((elemento) => {
                delete seleccion[elemento.infoSolicitud.idSolicitud];
                setcontenidoSeleccionado(seleccion);
            })
        } else {
            setcontenidoSeleccionado(nuevaSeleccion);
        }

    }

    const tablaCS = Object.values(contenidoSeleccionado);

    //Actualizar la tabla con el nuevo numero CUR 
    const actualizacionCurSel = useCallback(
        async (tablaCS: InfoPersonasHE[]) => {
            var copiaCont = [...tablaCS];
            let largo = copiaCont.length;

            for (let i = 0; i < largo; i++) {
                copiaCont[i].infoSolicitud.numeroCur = numeroCur;
                copiaCont[i].infoSolicitud.fechaCur = fechaCur;
            }

            copiaCont.map((c) => {
                c.infoSolicitud.fechaCur = null;
                c.infoSolicitud.fechaPago = null;
            })
            await EnvioDatos(copiaCont);
            await obtenerTablaInfo(mes, anio, false);
            setstatemes(null);
            setNumeroCur(null);
            setnuevoCur(true);
            setcontenidoSeleccionado([]);
        },
        [numeroCur, fechaCur, contentTabla]
    );

    async function EnvioDatos(tabla: InfoPersonasHE[]) {
        setloadingAccion(true);
        const respuesta = await ActualizarInfoTabla(tabla);
        if (respuesta.status === 200 || respuesta.status === 204 || respuesta.status === 202) {
            showAlert("Se han agregado los parámetros sin novedad", true)

        }
        else {
            const mensajeDefault = "Ha ocurrido un evento inesperado. Intente más tarde."
            showAlert(respuesta.errorMessage ?? mensajeDefault, false)
        }
        setloadingAccion(true);
    };

    async function onClickActualizar(numeroCur: number | null) {
        if (tablaCS.length > 0 && numeroCur !== null) {
            const texto = `<div class="custom-modal-content">
            <p>Esta seguro que desea agregar el numero de CUR: </p>
            <p> <strong>${numeroCur}</strong> </p>
            </div>`;

            const result = await Swal.fire({
                html: texto,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
                reverseButtons: true,
                customClass: {
                    cancelButton: 'btn-cancelar',
                    confirmButton: 'btn-aceptar',
                    popup: 'custom-popup'
                },
            });
            if (result.isConfirmed) {
                await actualizacionCurSel(tablaCS);
            } else if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {
                console.log("Se negó la acción.");
            } else {
                console.log("El modal fue cerrado sin realizar una acción.");
                return;
            }
        } else if (tablaCS.length === 0 && numeroCur !== null) {
            showAlert("No se ha seleccionado ningún elemento de la tabla", false);
        } else if (tablaCS.length > 0 && numeroCur == null) {
            showAlert("Debe ingresar un numero CUR", false);
        } else {
            showAlert("Seleccione un elemento e ingrese el numero CUR", false);
        }

    };
    //Presenta los datos de la tabla actualizados
    const ActualizarFechaPago = useCallback(
        async (tablaCS: InfoPersonasHE[], fechaPress: string) => {
            var CopiaTablaCS = [...tablaCS];
            CopiaTablaCS.forEach((c) => {
                c.infoSolicitud.fechaPago = fechaPress;
            });

            setContentTabla(CopiaTablaCS);
            setfechaPago(null);
        },
        []);


    const EnvioFechaPAgo = async (tablaCs: InfoPersonasHE[], fechaPresentar: string) => {
        var CopiaTablaEnvia = [...tablaCs];
        if (fechaPresentar) {
            const fechaA = fechaPresentar.split("/");
            const fechaEnvio = `${fechaA[2]}-${fechaA[1]}-${fechaA[0]}T00:00:00Z`

            CopiaTablaEnvia.forEach((c) => {

                c.infoSolicitud.fechaPago = fechaEnvio;
                c.infoSolicitud.fechaCur = null;
            });
            //Envio de datos
            await EnvioDatos(CopiaTablaEnvia);
            setconsultaCur(null);
            setnuevoCur(true);
            setcontenidoSeleccionado([]);
        }
    }


    const onClickGuardadFechaP = useCallback(
        async () => {
            if (tablaCS.length > 0) {
                if (fechaPago) {
                    const fechaPresentar = ObtenerFechaFormatoLocal(fechaPago);

                    const texto = `<div class="custom-modal-content">
                <p>Esta seguro que desea asignar la fecha: </p>
                <p> <strong>${fechaPresentar}</strong> </p>
            </div>`;

                    const result = await Swal.fire({
                        html: texto,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: 'Cancelar',
                        reverseButtons: true,
                        customClass: {
                            cancelButton: 'btn-cancelar',
                            confirmButton: 'btn-aceptar',
                            popup: 'custom-popup'
                        },
                    });

                    if (result.isConfirmed) {
                        setloadingAccion(true);
                        await ActualizarFechaPago(tablaCS, fechaPresentar);
                        await EnvioFechaPAgo(tablaCS, fechaPresentar);
                        setloadingAccion(false);
                    } else if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {
                        console.log("Se negó la acción.");
                    } else {
                        console.log("El modal fue cerrado sin realizar una acción.");
                        return;
                    }
                } else {
                    showAlert("Seleccione una fecha", false);
                }
            } else {
                showAlert("No se ha seleccionado ningún elemento de la tabla", false);
            }
        },
        [fechaPago,tablaCS]
    )

    //Editar numero Cur (por Error)
    const EditarNumeroCur = useCallback(
        async (editandoCur: InfoPersonasHE[] | undefined) => {
            // setloadingAccion(true);
            if (tablaCS.length > 0 && numeroCur) {

                if (editandoCur == undefined) {
                    setNumeroCur(null);
                    // setloadingAccion(false);
                    return -1;
                }
                if (consultaCur == null) {
                    showAlert("no existe CUR para editar", false);
                    setNumeroCur(null);
                    // setloadingAccion(false);
                    return -1;
                }

                //************  HABIAS COLOCADO OTRA VARIABLE AQUI, PUSISTE LA DE EDITANDO CUR, LA CUAL ESTABA VACIA*/
                /*   EL CONTENIDO SELECCIONADO AL PARECER SE GUARDA EN TABLACS  */
                var copiaTablCS = [...tablaCS];

                let largo = copiaTablCS.length;

                for (let i = 0; i < largo; i++) {
                    if (copiaTablCS[i].infoSolicitud.numeroCur === consultaCur) {
                        copiaTablCS[i].infoSolicitud.numeroCur = numeroCur;
                        copiaTablCS[i].infoSolicitud.fechaCur = fechaCur;
                    }

                }

                copiaTablCS.map((c) => {
                    c.infoSolicitud.fechaCur = null;
                    c.infoSolicitud.fechaPago = null;
                })
                const respuesta = await ActualizarInfoTabla(copiaTablCS);
                if (respuesta.status === 200 || respuesta.status === 204 || respuesta.status === 202) {
                    showAlert("Se han actualizado los par?metros sin novedad", true);
                    setnuevoCur(true);
                    setNumeroCur(null);
                    setconsultaCur(null);
                    setcontenidoSeleccionado([]);
                    // setloadingAccion(false);
                    return 1;

                }
                else {
                    const mensajeDefault = "Ha ocurrido un evento inesperado. Intente más tarde."
                    showAlert(respuesta.errorMessage ?? mensajeDefault, false);
                    setNumeroCur(null);
                    // setloadingAccion(false);
                    return -1;

                }
                setloadingAccion(false);
            } else {
                showAlert("No se ha seleccionado ningún elemento de la tabla", false);
                // setloadingAccion(false);
                return -1
            }
        }, [numeroCur, fechaCur, contentTabla]);

    function onChangeValue(e: any) {
        var valor = e.target.value
        if (valor) {
            valor = +valor;
        }
        setNumeroCur(valor)

        var hoy = new Date(Date.now());
        var fecha = GetDateObjectFromDate(hoy);
        if (fecha) {
            var fechaISO = ObtenerFechaTimeZoneLocalISO(fecha);
            var fechacur = ObtenerFechaFromIsoFormat(fechaISO);
            setFechaCur(fechacur);
        }
    };
    function onChange(e: any) {
        var valor = e.target.value
        if (valor) {
            valor = +valor;
        }
        setconsultaCur(valor);
    }
    function onClickFP() {
        setestadoPantalla("AF");
        setconsultaCur(CursUnico[0]);
    }

    useEffect(() => {

        if (estadoPantalla === "SA") {
            if (statemes !== null) {
                if (mes == 0) {
                    obtenerTablaInfo(1, anio, true);
                } else {
                    obtenerTablaInfo(mes, anio, false);
                }
            } else {
                const hoy = new Date();
                const mesHoy = hoy.getMonth();
                const anioHoy = hoy.getFullYear();
                if (mesHoy == 0) {
                    obtenerTablaInfo(1, anioHoy, true);
                }
                obtenerTablaInfo(mesHoy, anioHoy, false);
            }
        } else if (estadoPantalla === "AF") {
            if (consultaCur !== null && CursUnico.includes(consultaCur)) {
                obtenerTablaCUR(consultaCur);
            } else {
                var curUhoy = CursUnico[0];
                if (curUhoy) {
                    obtenerTablaCUR(curUhoy);
                    setconsultaCur(curUhoy);
                }
            }
        } else if (estadoPantalla === "EC") {
            if (consultaCur !== null && CursUnico.includes(consultaCur)) {
                obtenerTablaCUR(consultaCur);
            } else {
                var curUhoy = CursUnico[0];
                if (curUhoy) {
                    obtenerTablaCUR(curUhoy);
                    setconsultaCur(curUhoy);
                }
            }
        } else if (estadoPantalla === "PP") {
            if (consultaCur !== null && CursHistorico.includes(consultaCur)) {
                obtenerValoresCompletos(consultaCur);
            } else {
                var curHhoy = CursHistorico[0];
                if (curHhoy) {
                    obtenerValoresCompletos(curHhoy);
                    setconsultaCur(curHhoy);
                }

            }
        }

    }, [anio, mes, statemes, consultaCur, estadoPantalla, CursHistorico, CursUnico]);

    useEffect(() => {
        if (nuevoCur === true) {
            onInitComponent();
            setnuevoCur(false);
        }
        else if (estadoPantalla !== "SA") {
            onInitComponent();
        }

    }, [nuevoCur, estadoPantalla])


    const ContenidoModalEditandoCUR = useMemo(() => {

        if (consultaCur != null) {
            return (
                <React.Fragment>
                    <Row>
                        <Col xl={12}>
                            <Row>
                                <Col xl={12}>
                                    <span className={"labelParametrosHE"}> CUR Actual: </span>
                                </Col>
                                <Col xl={12}>
                                    <Input className="font-modal-he2" type="text" value={consultaCur} readOnly>
                                    </Input>
                                </Col>
                                <Col xl={12} className={"mt-2"}>
                                    <span className={"labelParametrosHE"}> Ingrese nuevo CUR: </span>
                                </Col>
                                <Col xl={12}>
                                    <Input className="font-modal-he2" type="text" value={numeroCur ? numeroCur : ""} onChange={(e) => {

                                        var valor = e.target.value;
                                        if (valor) {
                                            valor = +valor;
                                        }
                                        setNumeroCur(valor);
                                    }}>
                                    </Input>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                </React.Fragment>
            )
        } else {
            return (
                <div> No ha seleccionado ningun CUR para editar </div>
            )
        }

    }, [consultaCur, numeroCur])

    const ContenidoHistorialSPP = useCallback(() => {
        if (CursHistorico.length > 1) {
            return (
                <>
                    <Row>
                        <Col xl={2}>
                            <select id="CURs" className={""} onChange={(e) => { onChange(e) }}>
                                {CursHistorico.map((cu, i) => {
                                    return (
                                        <React.Fragment key={i}>
                                            <option
                                                className={"mt-2"}
                                                key={i}
                                                value={cu}>
                                                CUR {cu}
                                            </option>
                                        </React.Fragment>
                                    )
                                })}
                            </select>
                        </Col>
                    </Row>
                    <p></p>
                </>
            )
        } else if (CursHistorico.length === 1) {
            //setconsultaCur(CursHistorico[0]);
            return (
                <>
                    <Row>
                        <Col xl={2}>
                            <Label className={"mb-2"}>CUR {CursHistorico[0]}</Label>
                        </Col>
                    </Row>
                </>
            )
        } else {
            return (
                <div className="custom-modal-content">
                    <Row>
                        <Col xl={10}>
                            <FormGroup>
                                <Label className={"font-15"}> Aún no se Han asignado Fechas de pagos
                                </Label>
                            </FormGroup>
                        </Col>
                    </Row>
                </div>
            );
        }

    }, [CursHistorico])

    const ContenidoSolicitudesFirmadas = (
        <Row>
            <Col xl={2} className="d-flex align-items-center justify-content-start">
                <FormGroup>
                    <MonthDatePicker
                        value={statemes}
                        placeholderText={"Elegir mes de nomina"}
                        onChange={(e) => {
                            setstatemes(e);
                        }}
                        color="blue"
                    />
                </FormGroup>
            </Col>
            <Col xl={2} style={{ marginTop: -10 }} className="d-flex align-items-center justify-content-start">
                <FormGroup>
                    <Input
                        type="text"
                        placeholder="numero CUR"
                        text-align="center"
                        value={numeroCur ? numeroCur : ""}
                        onChange={(e) => {
                            onChangeValue(e);
                        }} />
                </FormGroup>
            </Col>
            <Col xl={2} style={{ marginTop: -10 }} className="d-flex align-items-center justify-content-start">
                <FormGroup>
                    <Button
                        className={"button-blue2-always"}
                        onClick={() => {
                            onClickActualizar(numeroCur);
                        }} >
                        Actualizar CUR de pagos
                    </Button>
                </FormGroup>
            </Col>
        </Row>
    );
    const asignarFechaP = useCallback(() => {
        if (CursUnico.length > 1) {
            return (
                <>
                    <Row>
                        <Col xl={2}>
                            <select id="CURs" className={""}
                                onChange={(e) => {
                                    onChange(e);
                                }}>
                                {CursUnico.map((cu, i) => {
                                    return (
                                        <React.Fragment key={i}>
                                            <option
                                                className={"mt-2"}
                                                key={i}
                                                value={cu}>
                                                CUR {cu}
                                            </option>
                                        </React.Fragment>
                                    )
                                })}
                            </select>
                        </Col>
                    </Row>
                    <p>
                    </p>
                </>

            )
        } else if (CursUnico.length === 1) {
            //setconsultaCur(CursUnico[0]);
            return (
                <>
                    <Row>
                        <Col xl={2}>
                            <Label className={"mb-2"}>CUR {CursUnico[0]}</Label>
                        </Col>
                    </Row>
                </>
            )
        }
    }, [CursUnico]);

    const ContenidoEditarCUR = useCallback(() => {
        if (CursUnico.length > 1) {
            return (
                <>
                    <Row>
                        <Col xl={2}>
                            <select id="CURs" className={""}
                                onChange={(e) => {
                                    onChange(e);
                                }}>
                                {CursUnico.map((cu, i) => {
                                    return (
                                        <React.Fragment key={i}>
                                            <option
                                                className={"mt-2"}
                                                key={i}
                                                value={cu}>
                                                CUR {cu}
                                            </option>
                                        </React.Fragment>
                                    )
                                })}
                            </select>
                        </Col>
                    </Row>
                    <p></p>
                    <Row>
                        <Col xl={2}>
                            <button
                                className={"button-blue2"}
                                onClick={() => {
                                    seteditandoCur(tablaCS);
                                }}>
                                Editar CUR
                            </button>
                        </Col>
                    </Row>
                    <p></p>
                </>
            )
        } else if (CursUnico.length === 1) {
            //setconsultaCur(CursUnico[0]);
            return (
                <>
                    <Row>
                        <Col xl={2}>
                            <Label className={"mb-2"}>CUR {CursUnico[0]}</Label>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={2}>
                            <button
                                className={"button-blue2"}
                                onClick={() => seteditandoCur(tablaCS)}>
                                Editar CUR
                            </button>
                        </Col>
                    </Row>
                    <p></p>
                </>
            )
        }
    }, [CursUnico]);

    return (
        <React.Fragment>
            <div className='content'>
                <div className="titulo_seccion mb-3">
                    {TITULO_PANTALLA}
                </div>
                <div>
                    <FormGroup>
                        <select id="opciones" className={""} onChange={(e) => setestadoPantalla(e.target.value)}>
                            <option value="PP"> Personas por Pagar </option>
                            <option value="SA"> Solicitudes Aprobadas </option>
                            <option value="AF"> Asignar Fecha de Pago </option>
                            <option value="EC"> Editar CUR </option>
                        </select>
                    </FormGroup>
                    {estadoPantalla === "PP" && (
                        <div>
                            {ContenidoHistorialSPP()}
                            {CursHistorico.length > 0 && (
                                <TableAsignacionCur
                                    contenidoInfo={contentTabla}
                                    SeleccionFilas={contenidoSeleccionado}
                                    estadoPantalla={estadoPantalla}
                                    CurPreferencial={consultaCur}
                                    CurporDefaultAF={CursUnico[0]}
                                    CurporDefaultPP={CursHistorico[0]}
                                    onSelectionChange={handleSelectionChange}
                                    statemes={statemes}
                                />
                            )}
                        </div>
                    )}
                    {estadoPantalla === "SA" && (
                        <div>
                            {ContenidoSolicitudesFirmadas}
                            {contentTabla.length > 0 && (
                                <TableAsignacionCur
                                    contenidoInfo={contentTabla}
                                    SeleccionFilas={contenidoSeleccionado}
                                    estadoPantalla={estadoPantalla}
                                    CurPreferencial={consultaCur}
                                    CurporDefaultAF={CursUnico[0]}
                                    CurporDefaultPP={CursHistorico[0]}
                                    onSelectionChange={handleSelectionChange}
                                    statemes={statemes}
                                />
                            )}
                            {contentTabla.length === 0 && (
                                <div className="custom-modal-content">
                                    <Row>
                                        <Col xl={10}>
                                            <FormGroup>
                                                <Label className={"font-15"}> Usted no tiene solicitudes pendientes de CUR <br />
                                                    ¿Desea asignar <a
                                                        className={"textEspolColor-blue2"}
                                                        onClick={() => onClickFP()} >
                                                        fecha de pago</a> ?
                                                </Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        </div>
                    )}
                    {estadoPantalla === "AF" && (
                        <div>
                            <div>
                                {CursUnico.length > 0 && (
                                    <div>
                                        {asignarFechaP()}
                                        <Row style={{ position: 'relative' }}>
                                            <Col xl={2} >
                                                <DatePickerBlueColor
                                                    value={fechaPago}
                                                    placeholder={"Asignar fecha de pago"}
                                                    id={"Asignarfechapago"}
                                                    name={"Asignarfechapago"}
                                                    onChange={(e) => {
                                                        setfechaPago(e);
                                                    }}
                                                    filter={(date: Date) => isWeekday(date)}
                                                />
                                            </Col>
                                            <Button
                                                style={{ position: 'relative', left: 20, top: -10 }}
                                                className={"button-blue2"}
                                                onClick={() => {
                                                    onClickGuardadFechaP();
                                                }} > Asignar Fecha de pago
                                            </Button>
                                        </Row>
                                        <TableAsignacionCur
                                            contenidoInfo={contentTabla}
                                            SeleccionFilas={contenidoSeleccionado}
                                            estadoPantalla={estadoPantalla}
                                            CurPreferencial={consultaCur}
                                            CurporDefaultAF={CursUnico[0]}
                                            CurporDefaultPP={CursHistorico[0]}
                                            onSelectionChange={handleSelectionChange}
                                            statemes={statemes}
                                        />
                                    </div>
                                )}
                                {CursUnico.length === 0 && (
                                    <div className="custom-modal-content">
                                        <Row>
                                            <Col xl={10}>
                                                <FormGroup>
                                                    <Label className={"font-15"}> No tiene Asignación de fecha de pago pendientes
                                                    </Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    {estadoPantalla === "EC" && (
                        <div>
                            {CursUnico.length > 0 && (
                                <>
                                    <div> {ContenidoEditarCUR()} </div>
                                    <div>
                                        <TableAsignacionCur
                                            contenidoInfo={contentTabla}
                                            SeleccionFilas={contenidoSeleccionado}
                                            estadoPantalla={estadoPantalla}
                                            CurPreferencial={consultaCur}
                                            CurporDefaultAF={CursUnico[0]}
                                            CurporDefaultPP={CursHistorico[0]}
                                            onSelectionChange={handleSelectionChange}
                                            statemes={statemes}
                                        />
                                    </div>
                                </>
                            )}
                            {CursUnico.length === 0 && (
                                <div className="custom-modal-content">
                                    <Row>
                                        <Col xl={10}>
                                            <FormGroup>
                                                <Label className={"font-15"}> No existen CURs para editar
                                                </Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
            <ModalCargando
                show={loadingAccion != false}
                textoCargando='Cargando Datos'
                size='md'
                onClose={() => setloadingAccion(false)}
            />

            <ModalConfirmacion
                idModal="ModalEditarActividadHE"

                show={editandoCUR !== undefined}
                size='lg'
                centered={true}
                asyncAccion={true}
                asyncClose={false}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                // nam
                mensajeConfirmacion=''
                nombreBotonAccion='Actualizar'
                nombreBotonCerrarModal='Cancelar'
                classNameBotonAccion='btnConfirmarHabActHE'
                classNameBotonCerrarModal2='btnCancelarHabActHE'
                onClose={() => seteditandoCur(undefined)}
                asyncOnClick={() => EditarNumeroCur(editandoCUR)}
                contentModal={ContenidoModalEditandoCUR}
                tituloModal='Editar CUR'
                useContainer={true}
            />
        </React.Fragment>
    )
}